var React = require('react');

function Starfill (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fill":"#FFBE18","points":"63.444,35.705 66.736,42.374 74.096,43.444 68.77,48.635 70.027,55.965 63.444,52.504 \r\n\t56.861,55.965 58.118,48.635 52.793,43.444 60.153,42.374 "}));
}

Starfill.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"21.303px","height":"20.261px","viewBox":"52.793 35.705 21.303 20.261","enableBackground":"new 52.793 35.705 21.303 20.261","xmlSpace":"preserve"};

module.exports = Starfill;

Starfill.default = Starfill;
